module.exports = __webpack_public_path__ + "static/media/203-303.d7df12ea.png";